// extracted by mini-css-extract-plugin
export default {"custom-modal-dialog":"CustomModal_custom-modal-dialog__S2T9x","calender-modal":"CustomModal_calender-modal__exE7D"};